// extracted by mini-css-extract-plugin
export default {"becomeDealerPage":"style_becomeDealerPage__wYmCP","becomeDealerInner":"style_becomeDealerInner__SYddw","loaderBox":"style_loaderBox__saVmb","successBox":"style_successBox__AX6mU"};